import React from 'react'
import { COLORS } from '@btime/constants'
import { find, map, prop } from 'ramda'

import AbsolutePageTemplate from '../../../../components/templates/AbsolutePageTemplate'
import PageHeader from '../_shared/PageHeader'
import ServiceOrderLoader, { useServiceOrder } from '../_load/ServiceOrderLoader'
import PdfOptionsFormHandler from '../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import Preview from '../../../../components/pdf/Preview'
import View from '../../../../components/pdf/View'
import Text, { Bold } from '../../../../components/pdf/Text'
import Separator from '../../../../components/pdf/Separator'
import Image from '../../../../components/pdf/Image'
import Page from '../../../../components/pdf/Page'
import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import { findReplyByQuestionId, toCurrency } from '../_helpers/pdfHelpers'
import { Justify } from '../_shared/Justify'

const Content = ({ repliesParent }) => {
  const { replies: repliesMain } = useServiceOrder()
  const replies = !!repliesParent ? repliesParent : repliesMain

  const projectDescription = findReplyByQuestionId(replies, 1781)?.value
  const totalCost = findReplyByQuestionId(replies, 1779)?.value
  const avgProject = findReplyByQuestionId(replies, 1780)?.value
  const implantationCost = findReplyByQuestionId(replies, 1752)?.value

  const listReplieReference = map(prop('reference'))(prop('value')(find(it => it.questionId === 1778)(replies)))

  const monthValue =
    findReplyByQuestionId(replies, 1760)?.value ||
    findReplyByQuestionId(replies, 1765)?.value ||
    findReplyByQuestionId(replies, 1769)?.value ||
    findReplyByQuestionId(replies, 1773)?.value ||
    findReplyByQuestionId(replies, 1777)?.value

  const quantityPerValue =
    findReplyByQuestionId(replies, 1757)?.value ||
    findReplyByQuestionId(replies, 1761)?.value ||
    findReplyByQuestionId(replies, 1766)?.value ||
    findReplyByQuestionId(replies, 1770)?.value ||
    findReplyByQuestionId(replies, 1774)?.value

  const unitOnPackValue =
    findReplyByQuestionId(replies, 1758)?.value ||
    findReplyByQuestionId(replies, 1762)?.value ||
    findReplyByQuestionId(replies, 1767)?.value ||
    findReplyByQuestionId(replies, 1771)?.value ||
    findReplyByQuestionId(replies, 1775)?.value

  const addValue =
    findReplyByQuestionId(replies, 1759)?.value ||
    findReplyByQuestionId(replies, 1763)?.value ||
    findReplyByQuestionId(replies, 1768)?.value ||
    findReplyByQuestionId(replies, 1772)?.value ||
    findReplyByQuestionId(replies, 1776)?.value

  const typeOfBillingName = findReplyByQuestionId(replies, 1756)?.value?.name || ''

  const investmentValue = findReplyByQuestionId(replies, 1752)?.value

  const deadLineImplantation = findReplyByQuestionId(replies, 1751)?.value

  return (
    <Text size="medium" align="justify">
      <View id="1" pageBreakAfter>
        <Header />
        <br />
        <Text size="medium" bold>
          Objetivo
        </Text>
        <br />
        O projeto tem como objetivo melhorar a eficiência operacional e reduzir custos através da digitalização e
        automação de processos, adotando a metodologia da Btime. Este esforço busca elevar a produtividade, minimizar
        erros e agilizar a tomada de decisões.
        <br />
        <br />
        <Text size="medium" bold>
          Destaques do Projeto com Btime:
        </Text>
        <br />
        <ul>
          <li>
            <Text size="medium" bold>
              Simplificação de Fluxos de Trabalho:
            </Text>
            <ul>
              <li>Btime é reconhecida por sua habilidade em simplificar processos complexos.</li>
              <li>Integração eficiente de sistemas e ferramentas.</li>
              <li>Experiência de usuário aprimorada para clientes e colaboradores.</li>
            </ul>
          </li>

          <li>
            <Text size="medium" bold>
              Automação e Integração Seguras:
            </Text>
            <ul>
              <li>A plataforma oferece soluções seguras para automação e integração de processos.</li>
              <li>Governança adaptável a diversos procedimentos corporativos.</li>
            </ul>
          </li>

          <li>
            <Text size="medium" bold>
              Abordagem de Baixo Código:
            </Text>
            <ul>
              <li>
                Facilita a gestão de processos em departamentos como RH, Operações, Finanças e Atendimento ao Cliente.
              </li>
              <li>Reduz a carga sobre o time de TI.</li>
            </ul>
          </li>

          <li>
            <Text size="medium" bold>
              Benefícios da Plataforma Btime:
            </Text>
            <ul>
              <li>Otimização ágil de processos com mínima necessidade de programação.</li>
              <li>Maior visibilidade, rastreabilidade e eficiência na gestão de processos.</li>
            </ul>
          </li>

          <li>
            <Text size="medium" bold>
              Objetivos do Projeto:
            </Text>
            <ul>
              <li>Alcançar uma operação mais eficiente e econômica.</li>
              <li>Melhorias significativas em produtividade e precisão operacional.</li>
            </ul>
          </li>
        </ul>
        <Text size="medium" bold>
          Escopo do Projeto
        </Text>
        <br />
        💡Estimamos total {totalCost}
        <ul>
          <li>
            <Text size="medium" bold>
              Média {avgProject}
            </Text>
          </li>
        </ul>
        <Text size="medium" bold>
          Objetivo do projeto
        </Text>
        <br />
        {projectDescription}
        <br />
        <br />
      </View>

      <View id="2" pageBreakAfter>
        <Header />
        <br />
        <Text size="medium" bold>
          Resumo Proposta Comercial
        </Text>
        <br />
        💡O que é Implantação/Setup? Consiste na etapa de configuração, estruturação e digitalização do ambiente do
        cliente. Isso inclui na alocação de analistas funcionais de nosso time para fazer toda a tradução do processo
        atual do cliente para o Workspace na Btime. Dessa forma, a implantação engloba as fases de mapeamento,
        digitalização, cadastro de dados, automatização e validação do processo.
        <ul>
          <li>Implantação - {toCurrency(implantationCost)} </li>
        </ul>
        <Table width="90%" center>
          <TableRow>
            <TableCol>
              <Text bold size="medium">
                Valor do investimento
              </Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium">
                {toCurrency(investmentValue)}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text bold size="medium">
                Itens
              </Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Prazo para implantação</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">{deadLineImplantation} horas</Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">
                Horas de pontos de contato com a equipe durante a trilha de implantação (divididas nos itens abaixo)
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Reunião de Kick-Off</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">✅</Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Reunião de Rollout</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">✅</Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Configuração do ambiente pelos implementadores</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">✅ a definir</Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Envio dos materiais de apoio padrões para auto implantação</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Material personalizado</Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Reunião de validação</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">✅ a definir</Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Consultoria e treinamento</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">✅ a definir</Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Envio dos materiais de treinamentos personalizados</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">✅</Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Raio-X após o rollout</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">✅ 30 - 60 - 90 dias</Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Ponto de contato: WhatsApp dedicado</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">✅</Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Ponto de contato: suporte</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">✅</Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Suporte no Chat na Btime em horário comercial</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">✅</Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Suporte em Grupo Whatsapp</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">✅</Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Gerente de Sucesso Dedicado</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">✅</Text>
            </TableCol>
          </TableRow>
        </Table>
        <br />
        <br />
      </View>
      <View id="" pageBreakAfter>
        <Header />
        <br />
        <Text size="medium" bold>
          Mensal - {toCurrency(monthValue)}
        </Text>
        <ul>
          <li>Preço por {typeOfBillingName}</li>
        </ul>
        <Table width="80%" center>
          <TableRow>
            <TableCol>
              <Text bold size="medium">
                Quantidade por mês
              </Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium">
                Valor mensal
              </Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium">
                Valor Unitario
              </Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium">
                Valor Adicional
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">{quantityPerValue}</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">{toCurrency(monthValue)}</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">{toCurrency(unitOnPackValue)} </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">{toCurrency(addValue)}</Text>
            </TableCol>
          </TableRow>
        </Table>
        <br />
        <Text size="medium" bold>
          Plano Enterprise
        </Text>
        <br />
        💡Para organizações que precisam de segurança, controle e suporte em nível corporativo para gerenciar e
        automatizar processos complexos ou conectados.
        <br />
        <br />
        <Table width="90%" center>
          <TableRow>
            <TableCol>
              <Text bold size="medium"></Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium">
                Funcionalidade
              </Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium"></Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium">
                Observação:
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Investimento</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Valor Mensal</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">{toCurrency(monthValue)}</Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Uso</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Log de Atividades (30 dias)</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('2fcda203-39a8-4129-bcdd-0b2e80b99152') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Uso</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Aplicativo Android e IOS</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('4167d5a4-5eb5-47c5-95d4-5221bfe3318a') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Uso</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Aplicativo online e offline</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('b10c4fa1-9399-4f13-b0d6-6012bf3dda6e') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Uso</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Exportação Excel</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('2ab2decd-1084-4147-aa42-ed20538f1238') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Uso</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Exportação PDF</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('e6700ba7-a062-476e-9146-5fc8a53cc918') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Funcionalidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Checklists customizáveis</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('58da82ad-44d3-4df2-938f-5e0340d6fb28') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Funcionalidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Usuarios</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('20bed4db-e2fb-4605-902d-c761d005170c') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Funcionalidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Locais</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('891351b4-58c2-43ed-ab33-b641e51d6ced') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Funcionalidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Atividades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('0160f7b8-526b-4f26-adbc-b9c76c218f70') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Funcionalidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Não conformidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('04c04a5a-ffa9-47b4-bdcf-99cf08c21b9e') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Funcionalidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Qrcodes</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('6a2ce7e5-b1b8-4336-ad25-89b7bb230168') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Funcionalidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Formulários</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('283f4659-54e6-4883-badd-9d26a06f02fe') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Workflow automatizado</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('059453ff-208a-4769-9013-4419d0813c78') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Integrações D4sign</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('6215d1b7-ce9a-4f2d-968b-5beb0c11f338') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('6215d1b7-ce9a-4f2d-968b-5beb0c11f338') ? (
                  <></>
                ) : (
                  <>Contratação à parte</>
                )}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Integrações WhatsApp</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('7dc4a08b-fcdb-44ef-8ca9-4ba28bfea5ae') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('7dc4a08b-fcdb-44ef-8ca9-4ba28bfea5ae') ? (
                  <></>
                ) : (
                  <>Contratação à parte</>
                )}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Integrações Slack</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('4b55e42f-780e-47ea-a1ea-fa9272e95d0a') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('4b55e42f-780e-47ea-a1ea-fa9272e95d0a') ? (
                  <></>
                ) : (
                  <>Contratação à parte</>
                )}
              </Text>
            </TableCol>
          </TableRow>
        </Table>
      </View>

      <View id="3" pageBreakAfter>
        <Header />
        <br />
        <Table width="90%" center>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Integrações SMS</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('cc7ac193-28a5-45fc-b8ac-661d52d5570c') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('cc7ac193-28a5-45fc-b8ac-661d52d5570c') ? (
                  <></>
                ) : (
                  <>Contratação à parte</>
                )}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Automações</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('2a672944-5e7e-4b62-8bad-f875c5ff7f41') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('2a672944-5e7e-4b62-8bad-f875c5ff7f41') ? (
                  <></>
                ) : (
                  <>Contratação à parte</>
                )}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Integrações customizáveis</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('30662ef4-90ba-4183-aec0-e4d7f106c61d') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('30662ef4-90ba-4183-aec0-e4d7f106c61d') ? (
                  <></>
                ) : (
                  <>Contratação à parte</>
                )}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Integrações Recorrentes</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('6be265e4-f34b-4b0d-beac-7df79ca2c93d') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Criação de cards em massa importando planilhas</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('b4f0fd51-213e-4d3f-bdfd-943b996d518b') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Treinamento e Suporte</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Acesso à Base de Conhecimento Btime</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('e15b7b7f-1ae5-423d-88a1-b055460a0a6e') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Treinamento e Suporte</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Suporte no Chat na Btime em horário comercial</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('90472388-e3e0-476e-b977-d1c8c9958b76') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Treinamento e Suporte</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Suporte em Grupo Whatsapp</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('f55b6410-3ae7-428d-a566-ddea26144aca') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Treinamento e Suporte</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Gerente de Sucesso Dedicado</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('2256ca8d-f74c-45a8-a894-948c4432529e') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('2256ca8d-f74c-45a8-a894-948c4432529e') ? (
                  <></>
                ) : (
                  <>Contratação à parte</>
                )}
              </Text>
            </TableCol>
          </TableRow>

          <TableRow>
            <TableCol>
              <Text size="medium">Privacidade e Segurança</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Single Sign-On</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('2256ca8d-f74c-45a8-a894-948c4432529e') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Visualizações e Relatórios</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Visualização Kanban</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('826b9785-b324-4dc8-851e-08171db2f0f8') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Relatórios e Dados Analíticos Corporativos</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Análises e relatórios dinâmicos padrões</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('628ca777-1be4-4782-9b16-871461819043') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Extensões</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Dashboards Customizados</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('0c7028c4-6d6f-4e66-8cf8-b23cc425a9cb') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('0c7028c4-6d6f-4e66-8cf8-b23cc425a9cb') ? (
                  <></>
                ) : (
                  <>Contratação à parte</>
                )}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Extensões</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Mapa</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('f0b0fb54-e256-463f-8853-50114aaa2e9d') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('f0b0fb54-e256-463f-8853-50114aaa2e9d') ? (
                  <></>
                ) : (
                  <>Contratação à parte</>
                )}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Extensões</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Segmentação</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('76c9a124-d968-4d54-9c0f-9ac5e7d6c1b6') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('76c9a124-d968-4d54-9c0f-9ac5e7d6c1b6') ? (
                  <></>
                ) : (
                  <>Contratação à parte</>
                )}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Extensões</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Data Lake</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('56086b9c-ad6b-48a0-a571-77322edaca14') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('56086b9c-ad6b-48a0-a571-77322edaca14') ? (
                  <></>
                ) : (
                  <>Contratação à parte</>
                )}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Extensões</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Sustentação</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('4d8c2232-d02c-4f2c-b40c-b230ea321d8d') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('4d8c2232-d02c-4f2c-b40c-b230ea321d8d') ? (
                  <></>
                ) : (
                  <>Contratação à parte</>
                )}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Extensões</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Gerador de documentos customizados</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('bff1d1b8-5441-417f-87b0-82e420be51a6') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('4d8c2232-d02c-4f2c-b40c-b230ea321d8d') ? (
                  <></>
                ) : (
                  <>Contratação à parte</>
                )}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Extensões</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Gerador de Documentos nativos</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('5a9a07b1-ea45-4a60-a9e5-7ecbfbf98177') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
        </Table>
        <br />
        <Text size="medium" bold>
          Serviços Adicionais
        </Text>
        <ul>
          <li>Valor Hora Desenvolvimento: R$150,00</li>
          <li>Valor hora Sustentação: R$150,00</li>
        </ul>
      </View>

      <View id="4" pageBreakAfter>
        <Header />
        <br />
        <Text size="medium" bold>
          Pacotes de Horas Anuais de Sustentação
        </Text>
        <br />
        <Table width="80%" center>
          <TableRow>
            <TableCol>
              <Text bold size="medium">
                {' '}
                Pacote de Horas
              </Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium">
                Valor da Hora
              </Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium">
                Valor do Pacote (Upfront)
              </Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium">
                Valor do Pacote (Parcelado)
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">120 horas</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">R$ 150,00</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">R$16.200,00</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">R$18.000,00</Text>
            </TableCol>
          </TableRow>

          <TableRow>
            <TableCol>
              <Text size="medium">150 horas</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">R$ 140,00</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">R$19.620,00</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">R$21.800,00</Text>
            </TableCol>
          </TableRow>

          <TableRow>
            <TableCol>
              <Text size="medium">180 horas</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">R$ 130,00</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">R$21.060,00</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">R$23.400,00</Text>
            </TableCol>
          </TableRow>

          <TableRow>
            <TableCol>
              <Text size="medium">200 horas</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">R$ 120,00</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">R$21.600,00</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">R$24.000,00</Text>
            </TableCol>
          </TableRow>
        </Table>
        <ul>
          <ul>
            <li>Desconto de 10% aplicado no pagamento Upfront</li>
          </ul>
        </ul>
        <br />
        Cada linha representa um pacote diferente, começando com um pacote de 120 horas e chegando até 200 horas. O
        valor da hora diminui à medida que o número de horas no pacote aumenta, sugerindo um desconto por volume. O
        pagamento antecipado (upfront) também parece oferecer um desconto adicional de 10% sobre o preço total.
        <br />
        <br />
        <Text size="medium" bold>
          Dashboard customizado - Power BI
        </Text>
        <ul>
          <li>
            Envolve o custo mensal de manutenção + custo de Setup
            <ul>
              <li>Desenvolvimento sob consulta</li>
            </ul>
          </li>
        </ul>
        <Image src="/pdfs/interno/dash-customizado-exemplo.png" maxWidth={480} />
        <br />
        <Text size="medium" bold>
          Lake
        </Text>
        <ul>
          <li>Setup + documentação + horas = sob consulta</li>
        </ul>
      </View>
    </Text>
  )
}

const Header = () => (
  <>
    <Grid justify="left" align="left">
      <Image src="/btime-logo-roxo.png" maxWidth={150} ignoreFixedSize />
    </Grid>
  </>
)
const TemplateInternoPropostaEnterprisePdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader id={id}>
        <PdfOptionsFormHandler initialState={{ fontBaseColor: COLORS.dark1 }}>
          <PageHeader templateId={parseInt(templateId)} />
          <Grid align="stretch">
            <Col flex={3} flex_mdd={0} hideOn="mdd" scroll height="calc(100vh - 5.3rem)">
              <Preview>
                <Page>
                  <Content />
                </Page>
              </Preview>
            </Col>
          </Grid>
        </PdfOptionsFormHandler>
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export const PropostaEnterprise = Content

export default TemplateInternoPropostaEnterprisePdfPage
